export { EventDetailBody } from "./EventDetailBody";
